// UI strings for Asetukset → Ylläpito → Puhelinten kunto (admin only; health/HealthAdmin.tsx): each
// device's latest heartbeat and the app's error log (engine/src/health.ts).
import { defineArea } from '../area';

export const phoneHealthFi = {
  title: 'Puhelinten kunto',
  devices: 'Laitteet',
  noDevices: 'Yksikään laite ei ole vielä lähettänyt tietojaan.',
  ios: (v: string) => `iOS ${v}`,
  otherSystem: 'muu kuin iPhone',
  installed: 'kotinäytöllä',
  inBrowser: 'selaimessa',
  seen: (when: string) => `viimeksi ${when}`,
  version: (b: string) => `versio ${b}`,
  kept: 'tallennustila pysyvä',
  notKept: 'tallennustila ei ole pysyvä: selain voi tyhjentää tiedot',
  keptUnknown: 'ei tietoa, onko tallennustila pysyvä',
  space: (used: string, quota: string) => `käytössä ${used} / ${quota}`,
  allSent: 'kaikki lähetetty',
  waiting: (n: number, age: string) => `lähettämättä ${n}, vanhin odottanut ${age}`,
  errors: 'Virheet',
  noErrors: 'Ei virheitä.',
  kinds: { error: 'Virhe', rejection: 'Epäonnistunut toiminto', render: 'Näkymä kaatui' },
  times: (n: number) => (n === 1 ? 'kerran' : `${n} kertaa`),
  where: 'Kohta koodissa',
  at: (date: string, time: string) => `${date} klo ${time}`,
  mb: (n: string) => `${n} Mt`,
  gb: (n: string) => `${n} Gt`,
};

export const phoneHealthEn: typeof phoneHealthFi = {
  title: 'Phone health',
  devices: 'Devices',
  noDevices: 'No device has sent its details yet.',
  ios: (v) => `iOS ${v}`,
  otherSystem: 'not an iPhone',
  installed: 'on the home screen',
  inBrowser: 'in the browser',
  seen: (when) => `last ${when}`,
  version: (b) => `build ${b}`,
  kept: 'storage persistent',
  notKept: 'storage not persistent: the browser may clear the data',
  keptUnknown: 'storage persistence unknown',
  space: (used, quota) => `using ${used} / ${quota}`,
  allSent: 'everything sent',
  waiting: (n, age) => `${n} unsent, the oldest waiting ${age}`,
  errors: 'Errors',
  noErrors: 'No errors.',
  kinds: { error: 'Error', rejection: 'Failed action', render: 'Screen crashed' },
  times: (n) => (n === 1 ? 'once' : `${n} times`),
  where: 'Place in the code',
  at: (date, time) => `${date} at ${time}`,
  mb: (n) => `${n} MB`,
  gb: (n) => `${n} GB`,
};

// Messages.phoneHealth (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('phoneHealth', phoneHealthFi, phoneHealthEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof phoneHealthFi> {}
}
